import React from 'react'
import type { BodyRowConfig } from '../types'
import type { OnChangeFunction } from '@ztechapps/webui.input'
import { CheckboxInput } from '@ztechapps/webui.input'

export type CheckboxBodyCellProps = {
  checked: boolean
  onChange: OnChangeFunction
  className?: string
  disabled?: boolean
} & Partial<BodyRowConfig>

export const CheckboxBodyCell = ({ checked, onChange, disabled, className }: CheckboxBodyCellProps) => {
  return (
    // Double-clicks on the checkbox select only — without the guard they bubble to the row and
    // fire onRowDoubleClick, toggling selection and navigating in one gesture.
    <td className={className} onDoubleClick={(e) => e.stopPropagation()}>
      <CheckboxInput checked={checked} onChange={onChange} disabled={disabled} />
    </td>
  )
}
